export function mountTestimonialVideos(root = document) {
	const triggers = root.querySelectorAll("[data-testimonial-video]");
	if (!triggers.length) return;

	const dialog = document.createElement("dialog");
	dialog.className = "studio-video-dialog";
	dialog.setAttribute("aria-label", "Video testimonial");
	const close = document.createElement("button");
	close.type = "button";
	close.className = "studio-video-dialog__close";
	close.textContent = "Close";
	close.setAttribute("aria-label", "Close video testimonial");
	const player = document.createElement("div");
	player.className = "studio-video-dialog__player";
	dialog.append(close, player);
	document.body.append(dialog);
	let previousOverflow = "";
	close.addEventListener("click", () => dialog.close());
	dialog.addEventListener("click", event => {
		if (event.target !== dialog) return;
		const box = dialog.getBoundingClientRect();
		if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
	});
	dialog.addEventListener("close", () => {
		player.replaceChildren();
		document.body.style.overflow = previousOverflow;
	});
	triggers.forEach(trigger => {
		if (trigger.dataset.videoMounted) return;
		trigger.dataset.videoMounted = "true";
		trigger.addEventListener("click", () => {
			const videoId = getVideoId(trigger.dataset.testimonialVideo);
			const title = trigger.dataset.videoTitle || "Video testimonial";
			dialog.setAttribute("aria-label", title);
			player.replaceChildren();
			if (videoId) {
				const iframe = document.createElement("iframe");
				iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;
				iframe.title = title;
				iframe.allow = "autoplay; encrypted-media; picture-in-picture; fullscreen";
				iframe.allowFullscreen = true;
				player.append(iframe);
			} else {
				player.textContent = "Please add a valid YouTube video link to this testimonial.";
			}
			previousOverflow = document.body.style.overflow;
			document.body.style.overflow = "hidden";
			dialog.showModal();
		});
	});
}

function getVideoId(value) {
	try {
		const url = new URL(value);
		if (url.protocol !== "https:") return null;
		let id;
		if (url.hostname === "youtu.be") id = url.pathname.split("/")[1];
		else if (["youtube.com", "www.youtube.com", "m.youtube.com"].includes(url.hostname)) {
			const parts = url.pathname.split("/");
			id = ["embed", "shorts", "live"].includes(parts[1]) ? parts[2] : url.searchParams.get("v");
		}
		return /^[\w-]{11}$/.test(id || "") ? id : null;
	} catch {
		return null;
	}
}
